import { InjectionToken, inject, type StaticProvider } from '@angular/core';

export const VEHICLE_MARKET_URL = new InjectionToken<string>('VEHICLE_MARKET_URL');

export function provideVehicleMarketUrl(vehicleMarketUrl: string): StaticProvider {
    return {
        provide: VEHICLE_MARKET_URL,
        useValue: vehicleMarketUrl,
    };
}

export function injectVehicleMarketUrl(): string | null {
    return inject(VEHICLE_MARKET_URL);
}
